import React, { useEffect, useState } from "react";
import FolderIcon from "@material-ui/icons/Folder";
import DescriptionIcon from "@material-ui/icons/Description";
import SVG from "react-inlinesvg";

import {
  OverlayTrigger,
  Popover,
  PopoverContent,
  PopoverTitle
} from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import VisibilityIcon from "@material-ui/icons/Visibility";

export default function LibraryGrid({
  folders,
  files,
  openEditLibraryPage,
  setCurrentItem,
  setOpenModal,
  id
}) {
  // * ONCLICK FOLDER
  const onClickFolder = (event, item) => {
    switch (event.detail) {
      case 2:
        openEditLibraryPage(item.uuid);
        break;

      default:
        break;
    }
  };

  // * ONCLICK FILE
  const onClickFile = (event, item) => {
    switch (event.detail) {
      case 2:
        window.open(`${item.storage}/${item.path}`);
        break;

      default:
        break;
    }
  };

  return (
    <div>
      {folders.length !== 0 && (
        <>
          <h5>Folders</h5>
          <div
            className="mb-16"
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            {folders.map(item => (
              <>
                <OverlayTrigger
                  trigger={"click"}
                  rootClose
                  overlay={
                    <Popover id="popover-positioned-right">
                      <PopoverTitle as="h3">Actions</PopoverTitle>
                      <PopoverContent>
                        <label
                          title="Delete image"
                          className="btn btn-icon btn-light btn-hover-info btn-sm mx-1"
                          onClick={() => openEditLibraryPage(item.uuid)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-info">
                            <VisibilityIcon />
                          </span>
                        </label>
                      </PopoverContent>
                    </Popover>
                  }
                >
                  <div
                    className="d-flex flex-column cursor-pointer border rounded p-4"
                    style={{
                      flex: "0 1 23%",
                      margin: 4,
                      textAlign: "center"
                    }}
                  >
                    <div
                      className="d-flex"
                      onClick={e => onClickFolder(e, item)}
                    >
                      <FolderIcon className="mx-1" style={{color: item.check_sharing ? '#6993FF' : ''}} />
                      {item.name}
                    </div>
                  </div>
                </OverlayTrigger>
              </>
            ))}
          </div>
        </>
      )}
      {files.length !== 0 && (
        <>
          {id && (
            <div>
              <h5>Files</h5>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap"
                }}
              >
                {files.map(item => (
                  <>
                    <OverlayTrigger
                      trigger={"click"}
                      rootClose
                      show={true}
                      overlay={
                        <Popover id="popover-positioned-right">
                          <PopoverTitle as="h3">Actions</PopoverTitle>
                          <PopoverContent>
                            <label
                              title="Open"
                              className="btn btn-icon btn-light btn-hover-info btn-sm mx-1"
                              onClick={() =>
                                window.open(`${item.storage}/${item.path}`)
                              }
                            >
                              <span className="svg-icon svg-icon-md svg-icon-info">
                                <VisibilityIcon />
                              </span>
                            </label>
                          </PopoverContent>
                        </Popover>
                      }
                    >
                      <div
                        className="d-flex flex-column cursor-pointer border rounded p-4"
                        style={{
                          flex: "0 1 23%",
                          margin: 4,
                          textAlign: "center"
                        }}
                      >
                        <div
                          className="p-4 h-100"
                          onClick={e => onClickFile(e, item)}
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center"
                          }}
                        >
                          {["jpg", "jpeg", "png", "webp"].includes(
                            item.type
                          ) ? (
                            <img
                              className="w-50"
                              src={`${item.storage}/${item.path}`}
                            />
                          ) : (
                            <DescriptionIcon
                              className="w-50"
                              style={{
                                fontSize: 105
                              }}
                            />
                          )}
                        </div>
                        <div
                          className="d-flex mt-2"
                          onClick={e => onClickFolder(e, item)}
                          style={{
                            marginTop: "auto"
                          }}
                        >
                          <DescriptionIcon className="mx-1" />
                          {item.filename}
                        </div>
                      </div>
                    </OverlayTrigger>
                  </>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
